export function createIntercomUserId(email: string, companyIdInZorro: string) {
  return `${email}+${companyIdInZorro}`;
}
